import { defineComponent as _defineComponent } from 'vue'
import NotificationService, { Notification } from '@/assets/js/services/NotificationService';
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Notifications',
  setup(__props) {

const notifications = ref<Notification[]>([]);

function onNotificationRemoved(notification: Notification) {
    NotificationService.onNotificationRemoved(notification);
}

onMounted(() => {
    NotificationService.onNotificationAdded = (n: Notification) => notifications.value.push(n);
    NotificationService.onNotificationRemoved = (n: Notification) => notifications.value = notifications.value.filter((value) => value !== n);
});


return { __sfc: true,notifications, onNotificationRemoved }
}

})